<template>
  <div>
    <van-nav-bar
      title="添加校园体育活动"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <van-form @submit="onSubmit">
      <van-field
        clearable
        v-model="title"
        name="title"
        label="活动标题"
        placeholder="活动标题"
        :rules="[{ required: true, message: '请填写活动标题' }]"
      />
      <van-field
        clearable
        v-model="location"
        name="location"
        label="活动地点"
        placeholder="活动地点"
        :rules="[{ required: true, message: '请填写活动地点' }]"
      />
      <van-cell title="活动地点" :value="'经度：'+this.coordinate.lng+',纬度'+this.coordinate.lat" @click="mapShow = true;"/>

      <van-field name="team" label="是否团队活动">
        <template #input>
          <van-radio-group v-model="team" direction="horizontal">
            <van-radio :name="true">是</van-radio>
            <van-radio :name="false">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-cell :title="team?'最大队伍数':'最大人数'">
        <van-stepper theme="round" v-model="maxp" integer/>
      </van-cell>
      <div v-show="team">
        <van-cell title="单个队伍最大数">
          <van-stepper theme="round" v-model="maxSize" integer/>
        </van-cell>
        <van-cell title="单个队伍最小数">
          <van-stepper theme="round" v-model="minSize" integer/>
        </van-cell>
      </div>
      <van-field
        v-model="introduction"
        rows="2"
        autosize
        name="introduction"
        clearable
        label="简介"
        type="textarea"
        maxlength="500"
        placeholder="活动简介"
        show-word-limit
        :rules="[{ required: true, message: '请填写活动简介' }]"
      />

      <van-field
        readonly
        clickable
        :value="endTime"
        name="endTime"
        label="截止时间"
        placeholder="点击选择活动截止时间"
        @click="endTimeShowPicker = true"
      />

      <van-popup v-model="endTimeShowPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          title="选择活动截止时间"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="endOnConfirm"
          @cancel="endTimeShowPicker = false"
        />
      </van-popup>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          添加校园体育活动
        </van-button>
      </div>
    </van-form>
    <van-dialog v-model="mapShow" :title="'经度：'+this.coordinate.lng+',纬度'+this.coordinate.lat">
      <t-map v-model="coordinate" :hight="300"></t-map>
    </van-dialog>
    <div style="padding: 30px"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  NavBar,
  Form,
  Field,
  Button,
  Dialog,
  Stepper,
  Cell,
  RadioGroup,
  Radio,
  Popup,
  DatetimePicker
} from 'vant';
import {AddCampusActivities} from "../../network/campus_activities"
import TMap from "@/components/content/TMap/TMap";

Vue.use(Form);
Vue.use(NavBar);
Vue.use(Field);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Stepper);
Vue.use(Cell);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Popup);
Vue.use(DatetimePicker);
export default {
  name: "AddCampusActivities",
  components: {TMap},
  data() {
    return {
      // CampusActivities title
      title: '',
      location: '',

      team: false,

      // Maximum number of people
      maxp: 1,
      // 单个队伍最大人数
      maxSize: 10,
      // 单个队伍最小人数
      minSize: 2,
      //Course introduction
      introduction: "",

      // map show dialog
      mapShow: false,
      coordinate: {
        // 纬度
        lat: 34.687650, // 经纬度可以先写死
        // 经度
        lng: 113.676959
      },

      // 活动参与截止时间
      endTime: '',
      endTimeShowPicker: false,
      currentDate: new Date(),
      minDate: new Date(),
      maxDate: this.GLOBAL.end_select_time,
      endUnixTime: '',
    };
  },
  methods: {
    Dialoginfo(title, message) {
      Dialog.alert({
        title,
        message
      }).then(() => {
        // on close
      });
    }
    ,
    onClickLeft() {
      // this.$router.back(-1);
      this.$router.replace("CampusActivities");
    }
    ,
    onSubmit(values) {
      if (this.maxSize < this.minSize) {
        this.Dialoginfo('提示', '单个队伍最大人数不得小于单个队伍最小人数');
        return
      }
      if (values.endTime === "") {
        this.Dialoginfo('提示', '活动截止时间时间不能为空');
        return;
      }
      AddCampusActivities(values.title, values.location,this.coordinate.lat,this.coordinate.lng, values.introduction, this.maxp, this.maxSize, this.minSize, values.team,this.endUnixTime).then(res => {
        if (res) {
          this.Dialoginfo('提示', '添加成功');
          this.maxp = 0;
          this.title = "";
          this.location = "";
        } else {
          this.Dialoginfo('提示', '添加失败');
        }
      });
    }
    ,
    endOnConfirm(value) {
      this.endUnixTime = value.getTime().toString();
      this.endTime = value.toLocaleString();
      this.endTimeShowPicker = false;
    },
  }
  ,
}
</script>

<style scoped>
.scroll {
  overflow-y: scroll;
  height: 100%;
}

.popup {
  z-index: 10002;
}
</style>
